import { render, staticRenderFns } from "./reasonForJudgment.vue?vue&type=template&id=9ecb2b08&"
import script from "./reasonForJudgment.vue?vue&type=script&lang=js&"
export * from "./reasonForJudgment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ecb2b08')) {
      api.createRecord('9ecb2b08', component.options)
    } else {
      api.reload('9ecb2b08', component.options)
    }
    module.hot.accept("./reasonForJudgment.vue?vue&type=template&id=9ecb2b08&", function () {
      api.rerender('9ecb2b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/reasonForJudgment.vue"
export default component.exports